import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region REFUNDED

function _Refunded(props) {
    const hasValue = props.data && props.data.HasRefund;
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Refunded = withLabelTokenParsing(_Refunded, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Refunded:
            if (data.ExchangeRate && data.ExchangeRate.Refunded != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Refunded, options);
            }
            break;
        case Token.Total.Refunded:
            if (data.Refunded != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Refunded, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Refunded', defaultValue, Token.Total.Refunded),
        Token.getWrappedTokenConfig('Refunded (Display Currency)', Token.DisplayCurrency.Refunded)
    ]
};
const TypeConfig = {
    panel: {
        block: LabelValueTypeConfig.panel.block,
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Refunded' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Refunded}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Refunded }))
    }
};

// #endregion REFUNDED

export {
    Refunded as Component,
    Tokens,
    TypeConfig
}